export enum OptionTypes {
  canReceiveEmails = 1,
  skipOnsiteBloggingApproval = 2,
  skipOnsiteCopyApproval = 3,
  skipOnsiteRecommendationApproval = 4
}
